import { render } from "./Enigme1.vue?vue&type=template&id=7ffdeb8a"
import script from "./Enigme1.vue?vue&type=script&lang=js"
export * from "./Enigme1.vue?vue&type=script&lang=js"

import "./Enigme1.vue?vue&type=style&index=0&id=7ffdeb8a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__